export default [{
  path: '/',
  name: 'main',
  component: require('@/components/main').default,
  redirect: "/home/activitySelect",
  children: [{
      path: 'scan',
      name: 'scan',
      component: require('@/components/util/scan').default,
      meta: ['scan']
    },
    {
      path: 'login',
      name: 'login',
      component: require('@/components/single/login').default,
      meta: ['login']
    },
    {
      path: 'forget',
      name: 'forget',
      component: require('@/components/single/forget').default,
      meta: ['forget']
    },
    {
      path: 'register',
      name: 'register',
      component: require('@/components/single/register').default,
      meta: ['register']
    },
    {
      path: 'home',
      name: 'home',
      component: require('@/components/single/home').default,
      meta: ['index', 'home'],
      redirect: '/home/activitySelect',
      children: [
        {
          path: 'activitySelect',
          name: 'activitySelect',
          component: require("@/components/single/activitySelect").default,
          meta: ['index', 'home', 'activitySelect']
        },
        {
          path: 'activityIndex',
          name: 'activityIndex',
          component: require("@/components/single/activity").default,
          meta: ['index', 'home', 'activityIndex']
        },
        {
          path: 'activityDetial',
          name: 'activityDetial',
          component: require("@/components/single/activityDetial").default,
          meta: ['index', 'home', 'activityDetial']
        },
        {
          path: 'mine',
          name: 'mine',
          component: require("@/components/single/mine").default,
          meta: ['index', 'home', 'mine']
        },
        {
          path: 'orderDetial',
          name: 'orderDetial',
          component: require("@/components/single/orderDetial").default,
          meta: ['index', 'home', 'orderDetial']
        }
      ]
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/router.js